/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Detail_Signals_Geo_GradeInputs */

const en_directory_detail_signals_geo_grade = /** @type {(inputs: Directory_Detail_Signals_Geo_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grade`)
};

const zh_directory_detail_signals_geo_grade = /** @type {(inputs: Directory_Detail_Signals_Geo_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`等级`)
};

/**
* | output |
* | --- |
* | "Grade" |
*
* @param {Directory_Detail_Signals_Geo_GradeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_detail_signals_geo_grade = /** @type {((inputs?: Directory_Detail_Signals_Geo_GradeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Detail_Signals_Geo_GradeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_detail_signals_geo_grade(inputs)
	return zh_directory_detail_signals_geo_grade(inputs)
});
export { directory_detail_signals_geo_grade as "directory.detail.signals.geo_grade" }